<script setup lang="ts">
import { computed, onBeforeMount } from 'vue';
import { IonIcon, IonLabel, IonTabBar, IonTabButton } from '@ionic/vue';
import { addIcons } from 'ionicons';
import {
  calendarOutline,
  homeOutline,
  informationCircleOutline,
  newspaperOutline,
} from 'ionicons/icons';

import moreIcon from '@/assets/img/icons/more.svg';
import { useTabRootNavigation } from '@/composables/useTabRootNavigation';
import { ENTITIES } from '@/constants';
import { useGlobalStore } from '@/stores/global';

addIcons({
  more: moreIcon,
});

const { handleTabBarClick } = useTabRootNavigation();

const globalStore = useGlobalStore();
const faqPageId = computed(() => globalStore.faqPageId);

onBeforeMount(() => globalStore.fetchFaqPageId());
</script>

<template>
  <ion-tab-bar
    slot="bottom"
    @click.capture="handleTabBarClick"
  >
    <ion-tab-button
      tab="home"
      href="/start"
    >
      <ion-icon :icon="homeOutline" />
      <ion-label>Home</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="news"
      :href="`/${ENTITIES.NEWS.PATH}`"
    >
      <ion-icon :icon="newspaperOutline" />
      <ion-label>News</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="events"
      :href="`/${ENTITIES.EVENT.PATH}`"
    >
      <ion-icon :icon="calendarOutline" />
      <ion-label>Events</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="faq"
      :href="`/${ENTITIES.PAGE.PATH}/${faqPageId}`"
    >
      <ion-icon :src="informationCircleOutline" />
      <ion-label>FAQ</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="pages"
      :href="`/${ENTITIES.PAGE.PATH}`"
    >
      <ion-icon name="more" />
      <ion-label>Mehr</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</template>
